"use client"

import { UNIVERSAL_LINK_STORE_URL } from "@/_constant/constant"
import NavigationBar, {
  NaviBackItem,
} from "@/components/common/navigationBar/NavigationBar"
import { rootPx } from "@/components/layout/RootPadding"
import { nativeBr } from "@/utils/nativeBr"
import Image from "next/image"
import { useRouter } from "next/navigation"

interface EmptyLayoutProps {
  icon?: string
  title: string
  desc?: string
  isHeader?: boolean
}

export interface ErrorPageLayoutProps extends EmptyLayoutProps {
  isNavigation?: boolean
  button?: string
  onButtonClick?: () => void
}

const { px } = rootPx

const ErrorPageLayout = ({
  isNavigation,
  icon,
  title,
  desc,
  button,
  isHeader,
  onButtonClick,
}: ErrorPageLayoutProps) => {
  const route = useRouter()
  const onClick = () => {
    if (onButtonClick) {
      onButtonClick()
      return
    }

    route.push(nativeBr.isEnabled ? "/" : UNIVERSAL_LINK_STORE_URL)
  }
  return (
    <div className="flex flex-1 flex-col items-center justify-center bg-rl-secondary_gray-scale-bg-01">
      {isNavigation && (
        <>
          <NavigationBar
            title={""}
            bgColor="bg-transparent"
            isScrolled={false}
            left={<NaviBackItem color={"bg-rl-gray-900"} />}
          />{" "}
        </>
      )}
      <div
        className={`flex h-full flex-1 flex-col items-center justify-center ${px}`}
      >
        {icon && (
          <Image
            src={icon}
            width={96}
            height={96}
            alt={"오류 이미지"}
            className="mb-4"
          />
        )}
        <span className="typo-rl-body1 font-medium text-rl-gray-font-press">
          {title}
        </span>

        {desc && (
          <span className="typo-rl-label mt-[2px] text-rl-gray-font-caption">
            {desc}
          </span>
        )}

        {button && (
          <button
            className="typo-rl-body2 mt-8 rounded-[6px] bg-rl-primary-normal px-4 py-2 font-medium text-rl-common-white"
            onClick={onClick}
          >
            {nativeBr.isEnabled ? button : "앱 설치하기"}
          </button>
        )}
        {/* header가 존재 시 하단에 30px 영역 확보 후 중앙정렬 */}
        {isHeader && <div className="h-[30px]"></div>}
      </div>
    </div>
  )
}

export default ErrorPageLayout
